import { useEffect, useRef } from "react";
import { videoStates } from "../utils/constants";

import { VideoPlayerInterface } from "../types/VideoPlayerInterface";

const VideoPlayer = ({
  src,
  active,
  shouldShow,
  updateState,
}: VideoPlayerInterface) => {
  const videoEl = useRef<HTMLVideoElement | null>(null);
  const cacheVersion = process.env.REACT_APP_CACHE;

  useEffect(() => {
    const video = videoEl.current;
    video?.addEventListener("playing", handleVideoPlay, true);

    return () => {
      video?.removeEventListener("playing", handleVideoPlay, true);
    };
  });

  useEffect(() => {
    updateState(videoStates.LOADING);
  }, [updateState, src]);

  useEffect(() => {
    const video = videoEl.current;
    if (active) {
      // ".currentTime" is not supported on ie11
      // video.currentTime = 0.01;
      setTimeout(() => {
        video?.play();
        updateState(videoStates.PLAYING);
      }, 500);
    }
  }, [updateState, active]);

  const handleVideoPlay = () => {
    if (!active) return;
    updateState(videoStates.PLAYING);
  };

  const handleCanPlayThrough = () => {
    if (active) return;
    const video = videoEl.current;
    video?.pause();
    updateState(videoStates.READY);
  };

  const videoSource = src ? `${src}?cache=${cacheVersion}` : '';

  return (
    <div
      className={`media-container ${active || shouldShow ? "show" : "hide"}`}
    >
      <div className="inner">
        <video
          ref={videoEl}
          className="player"
          src={videoSource}
          playsInline
          muted
          autoPlay
          preload="auto"
          onEnded={() => updateState(videoStates.ENDED)}
          onCanPlayThrough={handleCanPlayThrough}
        />
      </div>
    </div>
  );
};

export default VideoPlayer;
